import { useTranslation } from 'react-i18next';
import { MetricGroupConfig } from '../store/actuality.types';
import MetricGroupSettings from './MetricGroupSettings';

interface MetricGroupManagementProps {
  groups: Record<string, MetricGroupConfig>;
  onToggleVisibility: (groupId: string) => void;
  onUpdateOrder: (newOrder: Record<string, number>) => void;
}

const MetricGroupManagement = ({
  groups,
  onToggleVisibility,
  onUpdateOrder,
}: MetricGroupManagementProps) => {
  const { t } = useTranslation('feed');

  return (
    <div className="p-4">
      <MetricGroupSettings
        groups={groups}
        onToggleVisibility={onToggleVisibility}
        onUpdateOrder={onUpdateOrder}
      />
    </div>
  );
};

export default MetricGroupManagement;
